import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { KnBrFactSheetAdapter } from '../../connectors/kn-br-fact-sheet.adapter';
import {
  KnBrFactSheetActionTypes,
  KnBrFactSheetActions,
  KnBrFactSheetDetailsFailure,
  KnBrFactSheetDetailsSuccess,
} from '../actions/kn-br-fact-sheet.action';

@Injectable()
export class KnBrFactSheetEffects {
  constructor(private actions$: Actions<KnBrFactSheetActions>, private factSheetAdapter: KnBrFactSheetAdapter) {}

  //@Effect()
  getFactSheetDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(KnBrFactSheetActionTypes.KnBrFactSheetDetailsAction),
      mergeMap(() =>
        this.factSheetAdapter.getFactSheetDetails().pipe(
          map((data: any) => new KnBrFactSheetDetailsSuccess(data)),
          catchError((error: Error) => {
            return of(new KnBrFactSheetDetailsFailure(error));
          })
        )
      )
    )
  );
}
